import { REGEX } from '../../constants/regex.constants';

export function isValidDescription(descriptionText: string): boolean {
  if (!descriptionText) {
    return false;
  }

  return new RegExp(REGEX.description).test(descriptionText);
}
